<template>
  <div>
    <div
      class="btn-container"
      @click="openWin"
      title="Все выбранные вами слова"
      @mouseover="setPic(1)" 
      @mouseleave="setPic(2)"
    >
      <at-badge :value="selectedTerms.length" :show="selectedTerms.length > 0">
        <img :src="src" style="width: 80%" />
        <div class="btn-label">Ваш словарик</div>
      </at-badge>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    // список выбранных слов
    selectedTerms() {
      return this.$store.state.terms.termstack;
    },
  },
  data: () => ({
    src: '/static/lang/img/book.png'
  }),
  methods: {
    setPic(n) {
      if (n == 2) this.src = '/static/lang/img/book.png'
      else this.src = '/static/lang/img/book1.png'
    },
    // открытие словаря
    openWin() {
      this.$emit('btn-click');
      this.$router.push({ path: "dict" });
    },
  },
};
</script>

<style scoped>
.btn-container {
  position: absolute;
  bottom: 42px;
  left: 15px;
  width: 74px;
  height: 95px;
  cursor: pointer;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.75);
  padding: 5px;
  border-radius: 5px;
}
.btn-label {
  font-size: 14px;
  color: rgb(255, 255, 255) !important;
  text-shadow: rgb(0 0 0) 1px 0px 1px, rgb(0 0 0) 0px 1px 1px,
    rgb(0 0 0) -1px 0px 1px, rgb(0 0 0) 0px -1px 1px;
  text-align: center;
  line-height: 1;
  padding-top: 5px;
}
</style>